export default function Ellipsis() {
  return (
    <li key="...">
      <span
        className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300"
      >
        ...
      </span>
    </li>
  );
}
